
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/lucidchart-to-miro",
      function () {
        return require("private-next-pages/converter/lucidchart-to-miro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/lucidchart-to-miro"])
      });
    }
  